import * as yup from 'yup'
import { mapRules } from '@/utils'
import translation from 'i18next'
import dayjs from 'dayjs'

export const quotationPaymentsTermsSchema = yup.lazy((map) =>
  yup
    .object(
      mapRules(
        map,
        yup.object({
          amount_percentage: yup
            .number()
            .typeError(translation.t('errors:validation.numberType'))
            .min(1, translation.t('errors:validation.min', { min: 1 }))
            .required(),
          description: yup.string().required(),
          due_date: yup.date().typeError('invalid_date').required().nullable(),
        })
      )
    )
    .test(
      'due-dates-ascending',
      translation.t('errors:validation.dateNotEarlierThanPrevious'),
      function (paymentTerms) {
        if (!paymentTerms || typeof paymentTerms !== 'object') return true

        const keys = Object.keys(paymentTerms)

        let prevDate: dayjs.Dayjs | null = null

        for (const key of keys) {
          const value = paymentTerms[key]
          const current = value?.due_date ? dayjs(value.due_date) : null

          if (current && prevDate && current.isBefore(prevDate, 'day')) {
            return this.createError({
              path: `${key}.due_date`,
              message: translation.t(
                'errors:validation.dateNotEarlierThanPrevious'
              ),
            })
          }

          if (current) {
            prevDate = current
          }
        }

        return true
      }
    )
    .test(
      'due-dates-not-after-next',
      translation.t('errors:validation.dateNotLaterThanNext'),
      function (paymentTerms) {
        if (!paymentTerms || typeof paymentTerms !== 'object') return true

        const keys = Object.keys(paymentTerms)

        for (let i = 0; i < keys.length - 1; i++) {
          const key = keys[i]
          const nextKey = keys[i + 1]

          const currentVal = paymentTerms[key]
          const nextVal = paymentTerms[nextKey]

          const current = currentVal?.due_date
            ? dayjs(currentVal.due_date)
            : null
          const next = nextVal?.due_date ? dayjs(nextVal.due_date) : null

          if (current && next && current.isAfter(next, 'day')) {
            return this.createError({
              path: `${key}.due_date`,
              message: translation.t('errors:validation.dateNotLaterThanNext'),
            })
          }
        }

        return true
      }
    )
    .test(
      'total-percentage-100',
      translation.t('errors:validation.totalPercentageMustBe100'),
      function (paymentTerms) {
        if (!paymentTerms || typeof paymentTerms !== 'object') return true

        const keys = Object.keys(paymentTerms)

        if (keys.length === 0) return true

        let sum = 0

        for (const key of keys) {
          const val = paymentTerms[key]?.amount_percentage
          const num = typeof val === 'number' ? val : Number(val)

          if (!isNaN(num)) sum += num
        }

        const EPS = 1e-6

        if (Math.abs(sum - 100) > EPS) {
          const firstKey = keys[keys.length - 1]

          return this.createError({
            path: `${firstKey}.amount_percentage`,
            message: translation.t(
              'errors:validation.totalPercentageMustBe100'
            ),
          })
        }

        return true
      }
    )
)
